import { useTranslation } from "react-i18next";

import type { StorylineExhibitLinkState } from "@/features/studies/report/storyline";

interface StorylineExhibitLinkProps {
  state: StorylineExhibitLinkState;
  findingIndex: number;
  onOpenSlide?: (slideId: string) => void;
}

/**
 * A finding's link to its deck slide: "See slide N" (the viewer's pager
 * number) opens the Deck tab there; "Slide on its way" while the deck is
 * being built; nothing when no slide will show.
 */
export function StorylineExhibitLink(props: StorylineExhibitLinkProps) {
  const { state, findingIndex, onOpenSlide } = props;

  const { t } = useTranslation("app");

  const testId = `storyline-exhibit-link-${findingIndex}`;

  switch (state.kind) {
    case "live":
      return (
        <button
          type="button"
          className="self-start rounded-sm text-sm font-medium text-[hsl(var(--report-action))] underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          onClick={() => onOpenSlide?.(state.slideId)}
          data-testid={testId}
        >
          {t("studyReport.storyline.seeSlide", { number: state.number })}
        </button>
      );
    case "pending":
      return (
        <span
          role="link"
          aria-disabled="true"
          className="self-start text-sm text-muted-foreground"
          data-testid={testId}
        >
          {t("studyReport.storyline.slidePending")}
        </span>
      );
    case "hidden":
      return null;
    default: {
      const unhandled: never = state;
      return unhandled;
    }
  }
}
